import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import { Icon } from 'js/components';
import {
  getNormalizedParticipantScores,
  participantHasUnscoredResponse,
  RESPONDED_TILE,
} from '../../utilities';
import { sentimentColor } from 'js/utils/sentiment-question';

// TODO: specify required fields
const ParticipantBar = (props) => {
  const { assessment } = props;

  if (!(assessment && assessment.participants)) {
    return <div className="participant-bar" />;
  }

  const participantData = _.orderBy(
    assessment.participants.map((p) => {
      // Normalized rather than raw, so questions with different option counts
      // (or a borrowed answer set valued `1..5`) average together correctly.
      const responses = getNormalizedParticipantScores(assessment, p.id);

      const filteredResponses = _.filter(responses, (x) => x !== null);

      return {
        responses,
        overall:
          filteredResponses.length > 0
            ? _.sum(filteredResponses) / filteredResponses.length
            : null,
        id: p.id,
      };
    }),
    [(o) => (o.overall === null ? -1 : o.overall)],
    ['desc']
  );

  function selectParticipant(id) {
    props.onSelectParticipant(id);
  }

  return (
    <div className="participant-bar">
      {participantData.map((pd) => {
        const hasScored = pd.overall !== null;
        const hasUnscoredOnly =
          !hasScored && participantHasUnscoredResponse(assessment, pd.id);

        const style = hasScored
          ? { color: sentimentColor(pd.overall) }
          : hasUnscoredOnly
          ? { color: RESPONDED_TILE.washInk }
          : {};

        const classes = {
          'vote-none': !hasScored && !hasUnscoredOnly,
        };

        return (
          <span
            className="participant"
            key={pd.id}
            onMouseEnter={selectParticipant.bind(pd, pd.id)}
            onMouseLeave={selectParticipant.bind(pd, null)}
          >
            <Icon icon="user" className={classnames(classes)} style={style} />
          </span>
        );
      })}
    </div>
  );
};
ParticipantBar.defaultProps = {
  onSelectParticipant: () => {},
};

export default ParticipantBar;
